import React from "react";

export default function QuizQuestion({
  quiz,
  index,
  onOptionChange,
  selectedOptions,
}) {
  const { question, options } = quiz || {};
  const idPrefix = `option_${index}`;

  const handleOptionChange = (optionIndex, event) => {
    const checked = event.target.checked;
    onOptionChange(index, optionIndex, checked);
  };

  const optionElements = options.map((option, optionIndex) => {
    return (
      <label htmlFor={`${idPrefix}_${optionIndex + 1}`} key={optionIndex}>
        <input
          type="checkbox"
          id={`${idPrefix}_${optionIndex + 1}`}
          checked={selectedOptions?.[optionIndex]}
          onChange={(event) => handleOptionChange(optionIndex, event)}
        />
        {option.option}
      </label>
    );
  });

  return (
    <div className="space-y-8">
      <div className="quiz">
        <h4 className="question">{question}</h4>
        <form className="quizOptions">{optionElements}</form>
      </div>
    </div>
  );
}
